<template>
  <div class="f-col ctr login">
    <div class="f-col login-message">
      <span class="error-message" v-show="isAuthError">{{ errorMessage }}</span>
    </div>
    <form class="f-col ctr" @submit.prevent="handleFetchWorkspaces" v-if="step === 1">
        <div class="f-row ctr form-field">
          <label class="f-row ctr" for="username-field">
            <Icon icon="user" />
            <span class="hidden">Email</span>
          </label>
          <input
            class="f-row ctr"
            id="username-field"
            type="email"
            name="username"
            placeholder="Email"
            required
            v-model="email"
          />
        </div>
        <div class="f-row ctr form-field">
          <label class="f-row ctr" for="password-field">
            <Icon icon="lock" />
            <span class="hidden">Senha</span>
          </label>
          <input
            class="f-row ctr"
            id="password-field"
            type="password"
            name="password"
            placeholder="Senha"
            required
            v-model="password"
          />
        </div>
      <div class="f-row ctr form-submit">
        <button class="button-submit" type="submit" :disabled="isAuthLoading">
          <template v-if="isAuthLoading">
            <Icon
              icon="spinner"
              spin
              style="font-size: 22px; animation-duration: 1.2s"
            />
          </template>
          <template v-else>Buscar workspaces</template>
        </button>
      </div>
    </form>
    <form class="f-col ctr" @submit.prevent="handleSubmit" v-else-if="step === 2">
      <div class="f-row ctr form-field">
        <label class="f-row ctr" for="workspace-field">
          <Icon icon="home" />
          <span class="hidden">Workspace</span>
        </label>
        <select  class="f-row ctr" id="workspace-field" name="workspaceId" required v-model="workspaceId">
          <option value="">Selecione um workspace</option>
          <option v-for="workspace of workspaceOptions" :key="workspace.id" :value="workspace.id">{{workspace.name }}</option>
        </select>
      </div>
      <div class="f-row ctr form-submit">
        <button class="button-back" type="button" :disabled="isAuthLoading" @click="handleBack">
          Voltar
        </button>
        <button class="button-workspace-submit" type="submit" :disabled="isAuthLoading">
          <template v-if="isAuthLoading">
            <Icon
              icon="spinner"
              spin
              style="font-size: 22px; animation-duration: 1.2s"
            />
          </template>
          <template v-else>Acessar</template>
        </button>
      </div>
    </form>
    <div class="f-row ctr">
      <p class="redefine-message">
        Esqueceu a senha?
        <button @click="switchToForgotten">Clique aqui</button>
      </p>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Login',
  data() {
    return {
      step: 1,
      email: '',
      password: '',
      workspaceId: '',
      workspaceOptions: [],
      errorMessage: '',
    };
  },
  computed: {
    isAuthLoading() {
      return this.$store.state.auth.status === 'loading';
    },
    isAuthError() {
      return this.$store.state.auth.status === 'error';
    },
  },
  methods: {
    switchToForgotten() {
      this.$store.commit('PRELUDE_UPDATE_CONTEXT', 'forgotten');
    },
    async handleBack() {
      this.workspaceOptions = [];
      this.workspaceId = '';
      this.step = 1;
    },
    async handleFetchWorkspaces() {
      try {
        if (this.isAuthLoading) return;
        this.$store.commit('AUTH_REQUESTING')
        const { email, password } = this;
        const result = await axios.post(
          `${process.env.VUE_APP_ADMIN_API_URL}/user/login`,
          { username: email, password }
        );
        if(!result) {
          throw Error('E-mail e/ou senha inválido(s)');
        }
        this.$store.commit('AUTH_SUCCESS')
        this.workspaceOptions = result.data?.workspaces || [];
        this.step = 2;

      } catch (err) {
        console.log('eroeoreopreor')
        this.$store.commit('AUTH_ERROR', err)
        this.errorMessage = !(err.name === 'TypeError')
          ? err.message
          : 'Não foi possível realizar esta operação';
        this.workspaceOptions = [];
        document?.querySelector('#password-field')?.focus();
      }
    },
    async handleSubmit() {
      try {
        if (this.isAuthLoading) return;
        const { email, password, workspaceId } = this;
        await this.$store.dispatch('AUTH_REQUEST', { username: email, password, workspaceId });
        this.$router.push('/');
      } catch (err) {
        this.errorMessage = !(err.name === 'TypeError')
          ? err.message
          : 'Não foi possível realizar esta operação';
        this.password = '';
        document?.querySelector('#password-field')?.focus();
      }
    },
  },
};
</script>

<style scoped>
.login {
  margin: 0;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
}

.login-message {
  font-size: 14px;
  min-height: 22px;
  font-weight: 600;
  white-space: nowrap;
  text-align: center;
}

.error-message {
  color: #f33;
  white-space: pre-line;
}

.form-field {
  margin: 6px;
}

.form-field > input {
  width: 180px;
  height: 54px;
  padding: 0 16px;
  font-size: 14px;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  background-color: #f2f2f6;
}

.form-field > select {
  min-width: 180px;
  height: 54px;
  padding: 0 16px;
  font-size: 14px;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  background-color: #f2f2f6;
}

.form-field > label {
  height: 54px;
  width: 56px;
  font-size: 14px;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
  background-color: #7e8e9edf;
}

.form-submit {
  margin: 6px;
}

.button-submit {
  width: 268px;
  height: 54px;
  font-weight: 700;
  text-transform: uppercase;
  color: #eee;
  background-color: #25aae1;
  border-radius: 0.25rem;
}

.button-back {
  width: 130px;
  margin-right: 8px;
  height: 54px;
  font-weight: 700;
  text-transform: uppercase;
  color: #eee;
  background-color: #25aae1;
  border-radius: 0.25rem;
}

.button-workspace-submit {
  width: 130px;
  height: 54px;
  font-weight: 700;
  text-transform: uppercase;
  color: #eee;
  background-color: #25aae1;
  border-radius: 0.25rem;
}

.redefine-message {
  margin: 6px;
  font-size: 14px;
  color: #9f9f9f;
}

.redefine-message > button {
  padding: 0 2px;
  font-size: 14px;
  color: #f1f1f1;
}
</style>
